import React, { useState } from "react";
import { X } from "@phosphor-icons/react";

const CONTACT_EMAIL = "easywired@outlook.de";

const IMPRESSUM = (
  <div className="space-y-4 text-sm leading-relaxed">
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">Angaben gemäß § 5 TMG / § 18 Abs. 2 MStV</h3>
      <p>
        Surab Link
        <br />
        Robert-Kircher-Str. 4
        <br />
        36037 Fulda
        <br />
        Deutschland
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">Kontakt</h3>
      <p>
        E-Mail: <a href={`mailto:${CONTACT_EMAIL}`} className="text-volthover underline">{CONTACT_EMAIL}</a>
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">Verantwortlich für den Inhalt</h3>
      <p>Surab Link (Anschrift wie oben)</p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">Haftung für Inhalte</h3>
      <p className="text-muted">
        Die Inhalte dieser App wurden mit größter Sorgfalt erstellt. Antworten der KI werden automatisiert erzeugt und können
        Fehler enthalten. Sie stellen keine verbindliche fachliche, medizinische oder sicherheitstechnische Beratung dar.
        Für die Richtigkeit, Vollständigkeit und Aktualität der KI-Antworten wird keine Gewähr übernommen.
      </p>
    </section>
  </div>
);

const DATENSCHUTZ = (
  <div className="space-y-4 text-sm leading-relaxed">
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">1. Verantwortlicher</h3>
      <p className="text-muted">
        Surab Link, Robert-Kircher-Str. 4, 36037 Fulda, Deutschland – E-Mail:{" "}
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-volthover underline">{CONTACT_EMAIL}</a>
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">2. Grundsätze (Privacy by Design)</h3>
      <ul className="text-muted list-disc pl-4 space-y-1">
        <li>Es findet <strong className="text-white">keine Messung im Hintergrund</strong> statt. Sensoren werden nur ausgelesen, wenn du eine Messung aktiv startest und einwilligst.</li>
        <li>Sensor-Rohdaten werden <strong className="text-white">nur lokal auf deinem Gerät</strong> verarbeitet. Übertragen wird ausschließlich eine statistische Zusammenfassung (Mittelwert, Minimum, Maximum u. Ä.) – und erst, wenn du sie aktiv absendest.</li>
        <li>Die App benötigt <strong className="text-white">kein Nutzerkonto</strong>. Es wird lediglich eine zufällige, anonyme Geräte-ID erzeugt.</li>
      </ul>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">3. Verarbeitete Daten</h3>
      <ul className="text-muted list-disc pl-4 space-y-1">
        <li><strong className="text-white">Anonyme Geräte-ID:</strong> zufällig erzeugte Kennung zur Zuordnung deines Anfrage-Guthabens und deiner Chats (Art. 6 Abs. 1 lit. b DSGVO).</li>
        <li><strong className="text-white">Chat-Nachrichten & Sensor-Zusammenfassungen:</strong> werden gespeichert, damit du deinen Verlauf einsehen kannst, und zur Beantwortung an ein KI-Modell übermittelt (Art. 6 Abs. 1 lit. b DSGVO).</li>
        <li><strong className="text-white">Anhänge (nur Pro):</strong> von dir aktiv hochgeladene Bilder/Dateien werden ausschließlich zur Beantwortung deiner Anfrage an das KI-Modell übermittelt.</li>
        <li><strong className="text-white">Zahlungsdaten:</strong> Zahlungen werden über Stripe abgewickelt. Wir erhalten und speichern keine Kreditkarten- oder Kontodaten, sondern nur den Transaktionsstatus.</li>
        <li><strong className="text-white">Standort-, Kamera-, Mikrofon- und Sensordaten:</strong> nur nach ausdrücklicher Einwilligung je Messung (Art. 6 Abs. 1 lit. a DSGVO); die Einwilligung kann jederzeit durch Abbruch bzw. Nicht-Senden widerrufen werden.</li>
      </ul>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">4. KI-Verarbeitung</h3>
      <p className="text-muted">
        Zur Beantwortung deiner Fragen werden deine Nachricht, die Sensor-Zusammenfassung und ggf. Anhänge an
        OpenAI als KI-Anbieter übermittelt. Die Daten werden dort zur Erzeugung der Antwort verarbeitet und nicht für
        Werbezwecke verwendet.
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">5. Geteilte Experimente</h3>
      <p className="text-muted">
        Wenn du ein Experiment teilst, wird ein öffentlicher Link erzeugt. Jeder, der diesen Link kennt, kann Titel,
        Frage, Messdaten-Zusammenfassung und KI-Antwort einsehen. Du kannst Experimente jederzeit in der App löschen –
        damit wird auch der Link ungültig.
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">6. Speicherdauer</h3>
      <p className="text-muted">
        Chats, Experimente und Guthaben bleiben gespeichert, solange du die App nutzt. Du kannst Chats und Experimente
        jederzeit selbst löschen. Auf Anfrage per E-Mail löschen wir alle mit deiner Geräte-ID verknüpften Daten.
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">7. Deine Rechte (DSGVO)</h3>
      <p className="text-muted">
        Du hast das Recht auf Auskunft (Art. 15), Berichtigung (Art. 16), Löschung (Art. 17), Einschränkung (Art. 18),
        Datenübertragbarkeit (Art. 20) und Widerspruch (Art. 21) sowie das Recht, eine erteilte Einwilligung jederzeit zu
        widerrufen (Art. 7 Abs. 3). Wende dich dazu an{" "}
        <a href={`mailto:${CONTACT_EMAIL}`} className="text-volthover underline">{CONTACT_EMAIL}</a>. Zudem besteht ein
        Beschwerderecht bei einer Datenschutz-Aufsichtsbehörde (z. B. Der Hessische Beauftragte für Datenschutz und
        Informationsfreiheit).
      </p>
    </section>
    <section>
      <h3 className="font-heading text-lg font-bold mb-1">8. Berechtigungen der App</h3>
      <p className="text-muted">
        Kamera, Mikrofon, Standort und Bewegungssensoren werden vom System erst nach deiner Freigabe aktiviert und
        ausschließlich für die von dir gestartete Messung verwendet. Du kannst Berechtigungen jederzeit in den
        Systemeinstellungen entziehen.
      </p>
    </section>
    <p className="text-xs text-muted">Stand: Juni 2026</p>
  </div>
);

export default function Legal({ open, onClose }) {
  const [tab, setTab] = useState("impressum");
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[70] bg-black/60 backdrop-blur-xl flex items-end sm:items-center justify-center" onClick={onClose}>
      <div
        data-testid="legal-modal"
        onClick={(e) => e.stopPropagation()}
        className="w-full max-w-lg bg-bg border border-white/10 rounded-t-2xl sm:rounded-2xl max-h-[88dvh] flex flex-col"
      >
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/10">
          <h2 className="font-heading text-xl font-bold tracking-tight">RECHTLICHES</h2>
          <button data-testid="legal-close-btn" onClick={onClose} className="p-2 rounded-full bg-elevated border border-white/10">
            <X size={16} weight="bold" />
          </button>
        </div>
        <div className="flex gap-2 px-5 pt-4">
          <button
            data-testid="legal-tab-impressum"
            onClick={() => setTab("impressum")}
            className={`flex-1 py-2 rounded-xl text-sm font-semibold border transition-colors ${
              tab === "impressum" ? "bg-volt border-volt" : "bg-surface border-white/10 text-muted"
            }`}
          >
            Impressum
          </button>
          <button
            data-testid="legal-tab-datenschutz"
            onClick={() => setTab("datenschutz")}
            className={`flex-1 py-2 rounded-xl text-sm font-semibold border transition-colors ${
              tab === "datenschutz" ? "bg-volt border-volt" : "bg-surface border-white/10 text-muted"
            }`}
          >
            Datenschutz
          </button>
        </div>
        <div className="flex-1 overflow-y-auto p-5">{tab === "impressum" ? IMPRESSUM : DATENSCHUTZ}</div>
      </div>
    </div>
  );
}
